export default '/build/2d2a6a28.jpg'